import {
  ByDateCard,
  ByDateCardVariantEnum,
} from '@app/feature/statistics/components/by-date-card/by-date.card';
import { useCpmsBoGetRevenueByDayQuery } from '@service/cpms-bo-transaction-reports-revenue-statistics.service';

import { useFilters } from '../../context/filters.context';

export const RevenueByDayCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetRevenueByDayQuery({
    ...transformedFilters,
  });

  return <ByDateCard data={data} variant={ByDateCardVariantEnum.Revenue} />;
};
